import AppMenu from './AppMenu';
import AppSessionRefresh from '@components/appSessionRefresh';
import AppTopBar from './AppTopBar';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import ErrorComponent from '@components/error';
import React from 'react';
import RefreshPageChecker from '@components/RefreshPageChecker';
import cn from 'classnames';
import { configDataSelector } from 'ducks/config/selectors';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';

interface AppLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  mainContentClassName?: string;
}

function AppLayout(props: AppLayoutProps) {
  const userConfig = useSelector(configDataSelector);

  function fallbackRender({ error }: FallbackProps) {
    if (
      error.message?.includes('Failed to fetch dynamically imported module')
    ) {
      window.location.href = '/';
    }
    return <ErrorComponent />;
  }
  return (
    <div className={cn(styles.root, props.className)}>
      <RefreshPageChecker />
      <AppSessionRefresh />
      <div className={styles.header}>
        <AppTopBar title={props.title} />
      </div>
      <div
        className={cn(
          styles.menuBarCell,
          userConfig.isSidebarCollapsed && styles.sidebarCollapsed
        )}
      >
        <AppMenu />
      </div>

      <div className={cn(styles.mainContentCell, props.mainContentClassName)}>
        <ErrorBoundary fallbackRender={fallbackRender}>
          {props.children}
        </ErrorBoundary>
      </div>
    </div>
  );
}

export default AppLayout;
